//#region src/services/taskService/taskTypes.ts
const TASK_STATUSES = [
	"open",
	"active",
	"completed",
	"failed",
	"closed"
];
/**
* Whether the task is over — no further execution is expected without an
* explicit re-open. Every status that answers "yes" here is also exempt from the
* overdue styling: a finished task's past deadline is history, not a warning.
*
* Deliberately separate from {@link satisfiesDependency}: they agree on
* `completed` and `closed` but differ on `failed`, which is terminal yet must
* keep blocking.
*/
function isTerminal(status) {
	return status === "completed" || status === "failed" || status === "closed";
}
/**
* Whether this status satisfies a dependency — i.e. a task blocked on it may
* fire.
*
* `failed` is absent on purpose. An abandoned (`closed`) task satisfies one,
* because closing is a deliberate act that retires the branch; a successful
* (`completed`) task obviously does. There is no `undefined` case: status is
* required on every row.
*/
function satisfiesDependency(status) {
	return status === "completed" || status === "closed";
}
/**
* Whether the task is LIVE for execution: its execute date is a real trigger and
* the task is worth scheduling.
*
* Both live states qualify, and that is the point of having this predicate. The
* status says WHO the work is for — `open` is still being defined, `active` is
* ready and up for grabs — not whether the execute date means anything. Anything
* narrower silently strands work: a task is scheduled while `open` and then
* flipped to `active` when it is ready, and if `active` were excluded, that flip
* would delete the scheduled job and the execute moment would pass unfired.
*
* Everything terminal is excluded. Shared by BOTH servers — tracking decides
* which jobs to keep, main decides whether a fire may proceed — so the two can
* never disagree about which tasks are live.
*/
function isExecutable(status) {
	return status === "open" || status === "active";
}

//#endregion
export { TASK_STATUSES, isExecutable, isTerminal, satisfiesDependency };
//# sourceMappingURL=taskTypes.js.map